<template>
  <div class="dashboard-block" v-if="userIsActivated">
    <h2>Booking Agents</h2>

    <profile-manager-staff-form/>

    <div class="margin-20"></div>

    <ul class="item-detail item-detail-simple">
      <profile-manager-staff-list-item
        v-for="staffUser in staffUsers"
        :key="staffUser.id"
        :staff-user="staffUser"/>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { helpers } from 'mixins/users'
import ProfileManagerStaffForm from './ProfileManagerStaffForm'
import ProfileManagerStaffListItem from './ProfileManagerStaffListItem'

export default {
  mixins: [helpers],

  components: {
    ProfileManagerStaffForm,
    ProfileManagerStaffListItem
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('manager/staff', ['staffUsers'])
  },

  created () {
    this.getManagerStaffUsers({ id: this.user.id })
  },

  methods: {
    ...mapActions('manager/staff', ['getManagerStaffUsers'])
  }
}
</script>
